<template>
  <div class="news-hub__card-wrapper">
    <a :href="url"
       rel="nofollow"
       class="news-hub__card">
      <div v-if="image"
           class="news-hub__card-image-wrapper">
        <picture v-if="image">
          <source :srcset="image.url">
          <img :width="image.width"
               :height="image.height"
               :src="`${image.url}${image.url
                 && image.url.includes( '?' ) ? '&' : '?'}format=*`"
               :alt="image.alt">
        </picture>
        <news-hub-type v-if="type"
                       :type="type"></news-hub-type>
      </div>
      <div class="news-hub__card-content">
        <h4 v-if="heading"
            class="news-hub__card-heading">
          {{ heading }}
        </h4>
        <p v-if="description"
           class="news-hub__card-description">
          {{ description }}
        </p>
        <gl-link class="news-hub__card-link"
                 :as-dummy="true">
          {{ linkText }}<span class="sr-only"> - {{ heading }}</span>
        </gl-link>
      </div>
    </a>
  </div>
</template>

<script>
import NewsHubType from "~/Components/NewsHub/NewsHubType.vue";
import GlLink from "../Base/GlLink.vue";

export default {
  name: "NewsHubCard",
  components: {
    NewsHubType,
    GlLink,
  },
  props: {
    url: {
      type: String,
      required: true,
    },
    image: {
      type: Object,
      default: null,
    },
    heading: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    linkText: {
      type: String,
      default: "Read More",
    },
  },
};
</script>

<style></style>
